import { FileConfigInterface } from './file-config.interface';


export const fileConfigMock: FileConfigInterface = {
  fileApiUrl: 'https://localhost/mock/de/'
};
